<div class="grid" *ngIf="carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
    <span>{{'LBL_CONSULTANDO' | translate }}</span>
  </div>
</div>
<div *ngIf="!carInformacionInicial">
  <div class="grid">
    <div class="col-12">
      <p-panel header="{{ 'ALERTAS.LBL_PRINCIPAL' | translate }}">
        <form [formGroup]="formulario" (ngSubmit)="confirmarGuardado()" novalidate id="fAlertas" name="fAlertas">
          <div class="grid">
            <div class="col-12 md:col-3 lg:col-3">
              <div class="div-form">
                <label>{{ 'ALERTAS.LBL_CODIGO' | translate }}</label>
                <div *ngIf="!alerta">
                  <input type="text" pInputText id="codigo"
                         name="nomCodigo"
                         autocomplete="off"
                         formControlName="codigo"
                         maxlength="10"
                         (blur)="validarCodigo()"
                         codigos-reactive
                  >
                  <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.codigo.invalid">
                    {{ 'ALERTAS.LBL_CODIGO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                  </div>
                  <div class="p-message p-messages-error p-corner-all" *ngIf="codExiste">
                    {{ 'ALERTAS.MSG_CODIGOEXISTE' | translate}}
                  </div>
                </div>
                <div *ngIf="alerta && alerta.idAlerta">
                  <label class="falso-combo-texto">{{alerta.codigo}}</label>
                </div>
              </div>
            </div>
            <div class="col-12 md:col-5 lg:col-5">
              <div class="div-form">
                <label>{{ 'ALERTAS.LBL_NOMBRE' | translate }}</label>
                <input type="text" pInputText id="nombre"
                       name="nomNombre"
                       autocomplete="off"
                       formControlName="nombre"
                       [maxlength]="100"
                       capitalize-reactive
                >
                <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.nombre.invalid">
                  {{ 'ALERTAS.LBL_NOMBRE' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                </div>
              </div>
            </div>
            <div class="col-12 md:col-2 lg:col-2">
              <div class="div-form">
                <label>{{ 'ALERTAS.LBL_TIPOSALERTAS' | translate }}</label>
                <p-dropdown disableTab  id="tipoAlerta" name="nomTipoAlerta" [options]="lisTiposAlertas"
                            placeholder="{{ 'LBL_SELECCIONE' | translate}}"
                             formControlName="idTipoAlerta"
                            emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                            emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                            optionValue="value"
                            optionLabel="label"
                ></p-dropdown>
                <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idTipoAlerta.invalid">
                  {{ 'ALERTAS.LBL_TIPOSALERTAS' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                </div>
              </div>
            </div>
            <div class="col-12 md:col-2 lg:col-2 text-center">
              <p-checkbox label="{{ 'ALERTAS.LBL_ALERTAINTERNA' | translate}}" binary="true"
                          id="alerta"
                          name="nomAlerta"
                          formControlName="indicadorAlertaInterna"
                          (onChange)="cambiarAlertaInterna($event)"></p-checkbox>
            </div>
          </div>
          <div >
            <div *ngIf="!f.indicadorAlertaInterna.value"  class="grid">
              <div class="col-12 md:col-4 lg:col-4" >
                <div class="div-form">
                  <label>{{ 'ALERTAS.LBL_PERFILES' | translate }}</label>
                  <p-multiSelect id="idPerfil" name="nomIdPerfil" [options]="lisPerfiles"
                                 defaultLabel="{{ 'LBL_SELECCIONE' | translate}}"
                                 selectedItemsLabel="{0} {{ 'LBL_ELEMENTOSSELECCIONADOS' | translate}}"
                                 formControlName="idPerfil"
                                 emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                                 emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                                 optionValue="value"
                                 optionLabel="label"
                  ></p-multiSelect>
                  <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idPerfil.invalid">
                    {{ 'ALERTAS.LBL_PERFILES' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                  </div>
                </div>
              </div>
              <div class="col-12 md:col-4 lg:col-4">
                <div class="div-form">
                  <label>{{ 'ALERTAS.LBL_OFICINA' | translate }}</label>
                  <p-multiSelect id="idOficina" name="nomIdOficina" [options]="lisEstructurasFisicas"
                                 defaultLabel="{{ 'LBL_SELECCIONE' | translate}}"
                                 selectedItemsLabel="{0} {{ 'LBL_ELEMENTOSSELECCIONADOS' | translate}}"
                                 formControlName="idOficina"
                                 emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                                 emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                                 optionValue="value"
                                 optionLabel="label"
                  ></p-multiSelect>
                  <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idOficina.invalid">
                    {{ 'ALERTAS.LBL_OFICINA' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                  </div>
                </div>
              </div>
              <div class="col-12 md:col-4 lg:col-4">
                <div class="div-form">
                  <label>{{ 'ALERTAS.LBL_NOTA' | translate }}</label>
                  <p-dropdown disableTab  id="notaInterna" name="nomNotaInterna" [options]="lisNotaInterna"
                              placeholder="{{ 'LBL_SELECCIONE' | translate}}"
                               formControlName="notaInterna"
                              emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                              emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                              optionValue="value"
                              optionLabel="label"
                  ></p-dropdown>
                  <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.notaInterna.invalid">
                    {{ 'ALERTAS.LBL_NOTA' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                  </div>
                </div>
              </div>
            </div>
            <div class="grid">
              <div class="col-12 md:col-6 lg:col-6">
                <div class="div-form">
                  <label>{{ 'ALERTAS.LBL_VINCULACION' | translate }}</label>
                  <p-multiSelect id="idTipoVinculacion" name="nomIdTipoVinculacion" [options]="lisVinculaciones"
                                 defaultLabel="{{ 'LBL_SELECCIONE' | translate}}"
                                 selectedItemsLabel="{0} {{ 'LBL_ELEMENTOSSELECCIONADOS' | translate}}"
                                 formControlName="idTipoVinculacion"
                                 emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                                 emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                                 optionValue="value"
                                 optionLabel="label"
                  ></p-multiSelect>
                  <div class="p-message p-messages-error p-corner-all"
                       *ngIf="submitted && f.idTipoVinculacion.invalid">
                    {{ 'ALERTAS.LBL_VINCULACION' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                  </div>
                </div>
              </div>
              <div class="col-12 md:col-2 lg:col-2 text-center" *ngIf="!f.indicadorAlertaInterna.value">
                <label>{{ 'ALERTAS.LBL_TIPOCREDITO' | translate }}: </label>
              </div>
              <div class="col-12 md:col-2 lg:col-2 text-center" *ngIf="!f.indicadorAlertaInterna.value">
                <p-checkbox label="{{ 'ALERTAS.LBL_NUEVO' | translate}}" binary="true"
                            id="indicadorNuevoCredito"
                            name="nomIndicadorNuevoCredito"
                            formControlName="indicadorNuevoCredito"></p-checkbox>
              </div>
              <div class="col-12 md:col-2 lg:col-2 text-center" *ngIf="!f.indicadorAlertaInterna.value">
                <p-checkbox label="{{ 'ALERTAS.LBL_RENOVACION' | translate}}" binary="true"
                            id="indicadorRenuevaCredito"
                            name="nomIndicadorRenuevaCredito"
                            formControlName="indicadorRenuevaCredito"></p-checkbox>
              </div>
            </div>
          </div>
          <div class="grid">
            <div class="col-12 md:col-12 lg:col-12">
              <div class="div-form">
                <label>{{ 'ALERTAS.LBL_DESCRIPCION' | translate }}</label>
                <textarea pInputTextarea type="text" pInputText id="descripcion"
                          name="nomDescripcion"
                          autocomplete="off"
                          formControlName="descripcion"
                          capitalize-reactive
                          [maxlength]="500"
                ></textarea>
                <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.descripcion.invalid">
                  {{ 'ALERTAS.LBL_DESCRIPCION' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                </div>
              </div>
            </div>
          </div>
          <div class="grid form-footer-buttons"></div>
          <div class="grid">
            <div class="col-12 md:col-2 md:col-offset-4 lg:col-2 lg:col-offset-4 text-center">
              <p-radioButton label="{{ 'ALERTAS.LBL_DESCARTAR' | translate}}"
                             id="descartarAlertaOpc1"
                             name="descartarAlerta"
                             formControlName="descartarAlerta"
                             value="descartar" (onClick)="cambiar('descartar')"></p-radioButton>
            </div>
            <div class="col-12 md:col-2 lg:col-2 text-center">
              <p-radioButton label="{{ 'ALERTAS.LBL_ALERTA' | translate}}"
                             id="descartarAlertaOpc2"
                             name="descartarAlerta"
                             formControlName="descartarAlerta"
                             value="alerta" (onClick)="cambiar('alerta')"></p-radioButton>
            </div>
          </div>
          <div *ngIf="f.descartarAlerta.value === 'descartar'">
            <div class="grid">
              <div class="col-12 md:col-4 md:col-offset-1 lg:col-4 lg:col-offset-1">
                <div class="div-form">
                  <label>{{ 'ALERTAS.LBL_ESTADO' | translate }}</label>
                  <p-dropdown disableTab  id="idEstado" name="nomIdEstado" [options]="lisEstados"
                              placeholder="{{ 'LBL_SELECCIONE' | translate}}"
                               formControlName="idEstado"
                              emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                              emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                              optionValue="value"
                              optionLabel="label"
                  ></p-dropdown>
                  <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idEstado.invalid">
                    {{ 'ALERTAS.LBL_ESTADO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                  </div>
                </div>
              </div>
              <div class="col-12 md:col-4 md:col-offset-1 lg:col-4 lg:col-offset-1">
                <div class="div-form">
                  <label>{{ 'ALERTAS.LBL_CAUSAL' | translate }}</label>
                  <p-dropdown disableTab  id="idTipoCausalSolicitud" name="nomIdTipoCausalSolicitud" [options]="lisCausales"
                              placeholder="{{ 'LBL_SELECCIONE' | translate}}"
                               formControlName="idTipoCausalSolicitud"
                              emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                              emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                              optionValue="value"
                              optionLabel="label"
                  ></p-dropdown>
                  <div class="p-message p-messages-error p-corner-all"
                       *ngIf="submitted && f.idTipoCausalSolicitud.invalid">
                    {{ 'ALERTAS.LBL_CAUSAL' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="grid form-footer-buttons"></div>
          <div class="grid" *ngIf="f.descartarAlerta.value === 'alerta'">
            <div class="col-12 md:col-2 text-center">
              <div class="div-form"><br>
                <p-checkbox label="{{ 'ALERTAS.LBL_EXCEPCION' | translate}}" binary="true"
                            id="indicadorExcepcion"
                            name="nomIndicadorExcepcion"
                            formControlName="indicadorExcepcion" (click)="redefinirFormulario()"></p-checkbox>
              </div>
            </div>
            <div class="col-12 md:col-2 text-center" *ngIf="f.indicadorExcepcion.value">
              <div class="div-form"><br>
                <p-checkbox label="{{ 'ALERTAS.LBL_MANEJAADJUNTO' | translate}}" binary="true"
                            id="manejaAdjunto"
                            formControlName="indicadorManejaAdjunto"></p-checkbox>
              </div>
            </div>
            <div class="col-12 md:col-4  lg:col-4 " *ngIf="f.indicadorExcepcion.value">
              <div class="div-form">
                <label>{{ 'ALERTAS.LBL_NIVELAPROBACION' | translate }}</label>
                <p-dropdown disableTab  id="idNivel" name="nomIdNivel" [options]="lisNiveles"
                            placeholder="{{ 'LBL_SELECCIONE' | translate}}"
                             formControlName="idNivel"
                            emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                            emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                            optionValue="value"
                            optionLabel="label"
                ></p-dropdown>
                <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idNivel.invalid">
                  {{ 'ALERTAS.LBL_NIVELAPROBACION' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                </div>
              </div>
            </div>
            <div class="col-12 md:col-12 lg:col-12" *ngIf="f.indicadorExcepcion.value">
              <div class="div-form">
                <label>{{ 'ALERTAS.LBL_DEFINICIONEXCEPCION' | translate}}</label>
                <textarea pInputTextarea type="text" id="descripcionExcepcion"
                          name="descripcionExcepcion"
                          autocomplete="off"
                          maxlength="200"
                          formControlName="descripcionExcepcion"
                ></textarea>
                <div class="p-message p-messages-error p-corner-all"
                     *ngIf="submitted && f.descripcionExcepcion.invalid">
                  {{ 'ALERTAS.LBL_DEFINICIONEXCEPCION' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                </div>
                <div class="p-message p-messages-error p-corner-all" *ngIf="codExiste">
                  {{ 'ALERTAS.MSG_CODIGOEXISTE' | translate}}
                </div>
              </div>
            </div>

          </div>
          <div class="grid">
            <div class="col-12 md:col-12 text-center " style="margin-top:15px">
              <p-checkbox label="{{ 'ALERTAS.LBL_HABILITADO' | translate}}" binary="true"
                          id="indicadorHabilitado"
                          name="nomIndicadorHabilitado"
                          formControlName="indicadorHabilitado"></p-checkbox>
            </div>
          </div>
          <div class="grid form-footer-buttons">
            <div class="form-group col-12">
              <div *ngIf="!guardando">
                <a (click)="regresar(formulario.dirty)" class="cancelar">{{'BTN_CANCELAR' | translate }}</a>
                <button icon="fa fa-floppy-o" label="{{'BTN_GUARDAR' | translate }}"
                        type="submit"
                        pButton></button>
              </div>
              <div *ngIf="guardando">
                <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
                <span>{{'LBL_GUARDANDO' | translate }}</span>
              </div>
            </div>
          </div>
        </form>
      </p-panel>
      <div class="grid form-footer-buttons" *ngIf="alerta && alerta.idAlerta">
        <div class="form-group col-12">
          <button icon="fa fa-arrow-left" label="{{ 'BTN_REGRESAR' | translate }}" type="button"
                  pButton (click)="regresar(false)"></button>
        </div>
      </div>
    </div>
  </div>
</div>
<p-confirmDialog #cd>
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>
